import React, { useEffect, useState,useRef } from 'react';
import { BrowserRouter as Router, Route, Link, useParams, useNavigate } from 'react-router-dom';
import { AxiosInstance } from './components/utils';
import "./css/bootstrap.min.css";
import "./css/animate.min.css";
import "./css/style.css";
import "./css/responsive.css";
import "./css/light-color.css";
import "./css/floatlabel.css";
import "./css/customstyle.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ScrollToTop from 'react-scroll-to-top';
import { ToastContainer, toast } from 'react-toastify';
import { AddEvent } from './components/admin/addevent';
import LoginScreen from './components/admin/LoginScreen';
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";


function AdminHome() {
const auth = getAuth();
    const [loading, setLoading] = useState(false);
    const [isLoginSuccess,setIsLoginSuccess] = useState(false);
  
   
    if (loading) {
        return (<div id="preloader">
            <div id="status">
                <div className="spinner"></div>
            </div>
        </div>);
    }
    else {
        return (
            <>
            <div className="antialiased light-vz circle-v ">
           <LoginScreen auth={auth} loginHandler={setIsLoginSuccess} />
           
           <ToastContainer position="bottom-right"/>
           </div>
            </>
        );
    }
}
export default AdminHome;